import { render, staticRenderFns } from "./client-signup.vue?vue&type=template&id=7f7adf2f"
import script from "./client-signup.vue?vue&type=script&lang=ts"
export * from "./client-signup.vue?vue&type=script&lang=ts"
import style0 from "./client-signup.vue?vue&type=style&index=0&id=7f7adf2f&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f7adf2f')) {
      api.createRecord('7f7adf2f', component.options)
    } else {
      api.reload('7f7adf2f', component.options)
    }
    module.hot.accept("./client-signup.vue?vue&type=template&id=7f7adf2f", function () {
      api.rerender('7f7adf2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/client-signup.vue"
export default component.exports